import React, { useState, useEffect } from "react";
import { Button } from "antd";
import colors from "../../../styles/_colors.scss";

export const ActionButton = (props) => {
  const {
    text = "Save",
    type = "",
    variant = "solid",
    color = "",
    size = "middle",
    disabled = false,
    onClickFunction = () => {},
    loading = false,
    icon = null,
    width = null,
    height = null,
    danger = false,
    customStyle = {}, // Accept custom styles
  } = props;

  const style = {
    // backgroundColor: disabled ? colors.ccDisabled : color || colors.ccBlue,
    // color: disabled ? colors.ccDisabledText : "#fff",
    // border: "none",
    // fontWeight: "500",
    ...customStyle,
  };

  if (height) style.height = height;

  const [localLoading, setLocalLoading] = useState(loading);
  useEffect(() => setLocalLoading(loading), [loading]);

  return (
    <Button
      type={type}
      size={size}
      disabled={disabled}
      onClick={onClickFunction}
      loading={localLoading}
      icon={icon}
      style={style}
      danger={danger}
      onPointerDown={(e) => e.stopPropagation()}
      variant={variant}
    >
      {text}
    </Button>
  );
};
